module.exports = __webpack_public_path__ + "static/media/ic-toggle-on.9b05cc77.svg";